module.exports = __webpack_public_path__ + "assets/img/joinus.e9366fc3.jpg";